import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import Register from "./pages/register/Register";
import Impressum from "./pages/impressum/Impressum";
import Datenschutz from "./pages/datenschutz/Datenschutz";
import ResetPassword from "./pages/resetPassword/ResetPassword";
import Blog from "./pages/blog/Blog";
import CVAnonymizer from "./pages/cvAnonymizer/CVAnonymizer";
import Demo from "./pages/demo/Demo";
import Ads from "./pages/ads/Ads";
import DemoCall from "./pages/demoCall/DemoCall";
import { seoRoutes } from "./utils/seoRoutes";
import Maintenance from "./pages/maintenance/Maintenance";
import AGB from "./pages/agb/AGB";

if (import.meta.env.VITE_LOG_LEVEL === "debug") {
  console.debug = console.debug;
  console.info = console.debug;
} else if (import.meta.env.VITE_LOG_LEVEL === "info") {
  console.debug = () => {}; // Deaktiviert Debug-Logs
  console.info = console.debug;
} else if (import.meta.env.VITE_LOG_LEVEL === "warn") {
  console.debug = () => {}; // Deaktiviert Debug-Logs
  console.info = () => {}; // Deaktiviert Info-Logs
} else if (import.meta.env.VITE_LOG_LEVEL === "error") {
  console.debug = () => {}; // Deaktiviert Debug-Logs
  console.info = () => {}; // Deaktiviert Info-Logs
  console.warn = () => {}; // Deaktiviert Warn-Logs
}

function App() {
  console.debug("App component is being rendered");
  
  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/registeruser" element={<Register />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} /> {/* NEU */}
        <Route path="/reset-password" element={<ResetPassword />} />{" "}
        {/* Password Reset Page */}
        <Route path="/blog" element={<Blog />} /> {/* SEO Blog Overview Page */}
        <Route path="/blog/:slug" element={<Blog />} /> {/* Individual Blog Posts */}
        <Route path="/cv-anonymizer" element={<CVAnonymizer />} /> {/* CV Anonymizer */}
        <Route path="/demo" element={<Demo />} /> {/* Demo Request Page */}
        <Route path="/AGB" element={<AGB />} />
        <Route path="/ads" element={<Ads />} /> {/* Google Ads Landing Page */}
        <Route path="/vorstellung" element={<DemoCall />} /> {/* Hidden Demo Call Page */}
        {/* SEO Landing Pages - 229 programmatic pages */}
        {seoRoutes}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
